import { render, staticRenderFns } from "./PortalManager.vue?vue&type=template&id=41d35282&"
import script from "./PortalManager.vue?vue&type=script&lang=js&"
export * from "./PortalManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports